var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { css } from 'styled-components';

var textStyle = function textStyle(type) {
  return function () {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), function (_ref) {
      var light = _ref.light,
          variant = _ref.variant,
          inverted = _ref.inverted,
          _ref$size = _ref.size,
          size = _ref$size === void 0 ? 'medium' : _ref$size,
          _ref$theme$yoga = _ref.theme.yoga,
          baseFont = _ref$theme$yoga.baseFont,
          fontWeights = _ref$theme$yoga.fontWeights,
          pSize = _ref$theme$yoga.fontSizes[size],
          _ref$theme$yoga$color = _ref$theme$yoga.colors,
          color = _ref$theme$yoga$color[variant],
          text = _ref$theme$yoga$color.text,
          white = _ref$theme$yoga$color.white,
          _ref$theme$yoga$compo = _ref$theme$yoga.components.text[type],
          fontsize = _ref$theme$yoga$compo.fontsize,
          lineHeight = _ref$theme$yoga$compo.lineHeight,
          fontWeight = _ref$theme$yoga$compo.fontWeight,
          textTransform = _ref$theme$yoga$compo.textTransform,
          letterSpacing = _ref$theme$yoga$compo.letterSpacing;
      return "\n    font-size: " + (fontsize || pSize) + "px;\n    " + (letterSpacing ? "letter-spacing: " + letterSpacing + "px;" : '') + "\n    " + (lineHeight ? "line-height: " + lineHeight + "px;" : '') + "\n    " + (fontWeight ? "font-weight: " + fontWeight + ";" : '') + "\n    " + (light ? "font-weight: " + fontWeights.light + ";" : '') + "\n\n    font-family: " + baseFont.family + ";\n    color: " + (variant ? color : text.primary) + ";\n    " + (inverted ? "color: " + white + ";" : '') + "\n    " + (textTransform ? "text-transform: " + textTransform + ";" : '') + "\n  ";
    });
  };
};

export default textStyle;